// No builtin union for TypedArrays, only private TypedArray type
import { AttributeType } from "../../lmvtk/common/PropdbEnums";
export const EMPTY_ROW_FLAG = 1 << 7;
export function isStringType(attr) {
    return attr.dataType >= 20;
}
export function isNumericType(attr) {
    return attr.dataType === AttributeType.Integer
        || attr.dataType === AttributeType.Float
        || attr.dataType === AttributeType.Double
        || attr.dataType === AttributeType.DbKey;
}
export function fail(message) {
    throw new Error(message ?? 'no message');
}
